<template>
  <div v-show="showAppeal" :class="$style.toptips">
    <span :class="$style.tipstxt">{{ $t("f96075a6c8") }}</span>
    <span
      v-if="isCreator"
      :class="feedBacked ? $style.normalword : $style.linkword"
      @click="feedback"
      >{{ feedBacked ? $t("d22b2a0380") : $t("90446028cc") }}</span
    >
  </div>
</template>
<script>
import i18n from '@/i18n'
import { getAppeal, postAppeal } from '@/services/api'
import { mapState } from 'vuex'
export default {
  name: 'TopTips',
  data() {
    return {
      clicked: false,
      isFeedBack: false,
      showAppeal: false
    }
  },
  computed: {
    ...mapState(['fileInfo', 'userInfo']),
    feedBacked() {
      return this.clicked && this.isFeedBack
    },
    isCreator() {
      if (this.userInfo && this.fileInfo) {
        return this.userInfo.userid == this.fileInfo.creator.id
      }
      return false
    }
  },
  watch: {
    fileInfo(val) {
      val && this.getAppealStatus()
    }
  },
  methods: {
    getAppealStatus() {
      getAppeal(this.fileInfo.fileid).then((res) => {
        const status = {
          VERIFY: 'verifying',
          //机审
          MANUAL: 'manual_verifying',
          //人工审核中
          OK: 'ok',
          //审核通过
          FORBID: 'forbid' //封禁状态
        }
        const appeal = {
          NO_APPEAL: 0,
          //未申诉
          APPEALING: 1,
          //申诉中
          FINISH: 2 //已完成
        }
        const data = res.data
        this.showAppeal = data.status === status.FORBID
        this.isFeedBack = data.is_appealing !== appeal.NO_APPEAL
      })
    },
    feedback() {
      this.clicked = true
      postAppeal(this.fileInfo.fileid)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(i18n.t('4ca22157a0'))
            this.getAppealStatus()
          }
        })
        .catch((err) => {
          console.log(err)
          this.$message.error(i18n.t('1d3c1de9d7'))
        })
    }
  }
}
</script>
<style lang="scss" module>
.toptips {
  user-select: none;
  position: absolute;
  min-width: 300px;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f1f1;
  border: 1px solid #f5c1c1;
  font-size: 14px;
  .tipstxt {
    color: #7f7e7e;
    margin-right: 5px;
  }
  .normalword {
    color: #000;
  }
  .linkword {
    color: rgb(39, 134, 242);
    cursor: pointer;
    &:hover,
    &:active {
      color: rgb(132, 182, 240);
      text-decoration: underline;
    }
  }
}
</style>
